var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobifone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.56 33.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec1c24;}.cls-2{fill:#0060ae;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    className: "cls-1",
    d: "M162,12.12h0Zm18.26,4.66h0a6.46,6.46,0,0,0-1.42-2.84h0a7.16,7.16,0,0,0-3.72-2.17,27,27,0,0,0-6.45-.56,18.78,18.78,0,0,0-6.65.92,6,6,0,0,0-1.86,1.22V12.28H156V33.72h4.11V20.1c0-3.55,3.63-5,7.25-5h1.82c3.62,0,7.29,1.4,7.29,5V33.72h4.06V22a26.1,26.1,0,0,0-.33-5.24Z",
    transform: "translate(-0.44 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    d: "M111,11.14h4.09a32.46,32.46,0,0,1,.36-5.24,4.59,4.59,0,0,1,1.24-2.38,6.42,6.42,0,0,1,3-1.9,27.09,27.09,0,0,1,6.1-.67h3.85l-3.7,3.61h-1.57c-5.45,0-5.06,3.48-5.06,6.57h9.58L125,15.08h-5.8l0,18.61h-4.14V15.08H111V11.14Z",
    transform: "translate(-0.44 -0.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-1",
    points: "106.45 3.14 106.45 7.34 110.55 7.34 110.55 3.14 106.45 3.14 106.45 3.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    className: "cls-2",
    d: "M75.26,22.47a18.08,18.08,0,0,1-.89,6.21C73.78,30.32,71.74,34,61.84,34s-11.93-3.68-12.53-5.32a18.09,18.09,0,0,1-.89-6.21,18.09,18.09,0,0,1,.89-6.21c.6-1.63,2.63-5.31,12.53-5.31s11.93,3.68,12.53,5.31a18.08,18.08,0,0,1,.89,6.21Zm-5.18-4.93h0A3.2,3.2,0,0,0,68,15.67a24.15,24.15,0,0,0-6.18-.58,24.14,24.14,0,0,0-6.18.58,3.2,3.2,0,0,0-2.06,1.88A14.54,14.54,0,0,0,53,22.47a14.55,14.55,0,0,0,.65,4.93,3.2,3.2,0,0,0,2.06,1.88,24.08,24.08,0,0,0,6.18.58A24.09,24.09,0,0,0,68,29.28a3.2,3.2,0,0,0,2.06-1.88,14.51,14.51,0,0,0,.65-4.93,14.51,14.51,0,0,0-.65-4.93Z",
    transform: "translate(-0.44 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    className: "cls-1",
    d: "M153,22.47a18.09,18.09,0,0,1-.89,6.21c-.6,1.63-2.64,5.32-12.53,5.32s-11.93-3.68-12.53-5.32a18.1,18.1,0,0,1-.89-6.21,18.1,18.1,0,0,1,.89-6.21c.6-1.63,2.63-5.31,12.53-5.31s11.93,3.68,12.53,5.31a18.09,18.09,0,0,1,.89,6.21Zm-5.18-4.93h0a3.2,3.2,0,0,0-2.06-1.88,24.15,24.15,0,0,0-6.18-.58,24.14,24.14,0,0,0-6.18.58,3.2,3.2,0,0,0-2.06,1.88,14.51,14.51,0,0,0-.65,4.93,14.51,14.51,0,0,0,.65,4.93,3.2,3.2,0,0,0,2.06,1.88,24.08,24.08,0,0,0,6.18.58,24.09,24.09,0,0,0,6.18-.58,3.2,3.2,0,0,0,2.06-1.88,14.54,14.54,0,0,0,.65-4.93,14.53,14.53,0,0,0-.65-4.93Z",
    transform: "translate(-0.44 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_4",
    "data-name": "<Compound Path>",
    className: "cls-2",
    d: "M26.67,12h0Zm0,0Zm18.47,4.78h0a6.45,6.45,0,0,0-1.43-2.84h0A7.23,7.23,0,0,0,40,11.73a27,27,0,0,0-6.46-.56,20.48,20.48,0,0,0-6.82.81h0a6,6,0,0,0-2.95,2.35,6.59,6.59,0,0,0-3.27-2.4,28.85,28.85,0,0,0-7.88-.76,18.62,18.62,0,0,0-5.6.58H7a7.1,7.1,0,0,0-2.41,1.6v-1.1H.44V33.68H4.53V20.06c0-3.55,3.61-5,7.26-5h1.83c3.65,0,7.3,1.4,7.3,5V33.68H25V20.06c0-3.55,3.57-5,7.22-5h1.83c3.65,0,7.31,1.4,7.31,5V33.68h4.09V22a25.88,25.88,0,0,0-.33-5.24Z",
    transform: "translate(-0.44 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_5",
    "data-name": "<Compound Path>",
    className: "cls-1",
    d: "M207.86,24H210c0-.5,0-1,0-1.57a18.06,18.06,0,0,0-.89-6.21c-.6-1.63-2.63-5.31-12.53-5.31s-11.93,3.68-12.53,5.31a18.1,18.1,0,0,0-.89,6.21,18.1,18.1,0,0,0,.89,6.21c.6,1.63,2.64,5.32,12.53,5.32s11.93-3.68,12.53-5.32c.05-.14.1-.29.15-.44h-4.94a3.39,3.39,0,0,1-1.56,1,33,33,0,0,1-12.35,0,3.2,3.2,0,0,1-2.06-1.88,11.44,11.44,0,0,1-.6-3.34h20.11v0Zm-17.45-8.37h0a32.93,32.93,0,0,1,12.35,0,3.2,3.2,0,0,1,2.06,1.88,10,10,0,0,1,.54,2.63H187.8a9.91,9.91,0,0,1,.54-2.63,3.2,3.2,0,0,1,2.06-1.88Z",
    transform: "translate(-0.44 -0.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-2",
    points: "106.45 10.19 106.45 32.73 110.55 32.73 110.55 10.19 106.45 10.19 106.45 10.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_6",
    "data-name": "<Compound Path>",
    className: "cls-2",
    d: "M103.12,16.26c-.6-1.63-2.63-5.31-12.53-5.31a21.83,21.83,0,0,0-8.26,1.3V1H78.24V33.74h4.09v-1A21.83,21.83,0,0,0,90.59,34c9.9,0,11.93-3.68,12.53-5.31a18.08,18.08,0,0,0,.89-6.21,18.08,18.08,0,0,0-.89-6.21ZM98.83,27.4h0a3.2,3.2,0,0,1-2.06,1.88,24.05,24.05,0,0,1-6.18.58,18.73,18.73,0,0,1-5.6-.58,3.2,3.2,0,0,1-2.06-1.88,11.77,11.77,0,0,1-.6-3.46V21a11.76,11.76,0,0,1,.6-3.46A3.2,3.2,0,0,1,85,15.67a18.79,18.79,0,0,1,5.6-.58,24.14,24.14,0,0,1,6.18.58,3.2,3.2,0,0,1,2.06,1.88,14.52,14.52,0,0,1,.65,4.93,14.52,14.52,0,0,1-.65,4.93Z",
    transform: "translate(-0.44 -0.95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobifone);
export default __webpack_public_path__ + "static/media/logo-mobifone.0f774b47e2a79b86c97f33b625b15b5f.svg";
export { ForwardRef as ReactComponent };